document.addEventListener('DOMContentLoaded', () => {
  //== Wrap overflowing tables in scrollable container
  const wrapTables = () => {
    const main = document.querySelector('main')
    if (!main) return

    const tables = main.querySelectorAll('table')

    tables.forEach((table) => {
      const parent = table.parentElement

      //== Skip if already wrapped in .table-scroll
      if (parent && parent.classList.contains('table-scroll')) {
        return
      }

      //== Check if table overflows its container or has no offsetParent
      const tableOverflows = table.offsetWidth > table.parentElement.offsetWidth
      const isDetached = table.offsetParent === null

      if (tableOverflows || isDetached) {
        //== Create wrapper divs
        const tableContent = document.createElement('div')
        tableContent.classList.add('table-content')

        const tableScroll = document.createElement('div')
        tableScroll.classList.add('table-scroll')

        //== Add accessibility attributes
        tableScroll.setAttribute('tabindex', '0')
        tableScroll.setAttribute('role', 'region')
        tableScroll.setAttribute('aria-label', 'Scrollable table area')

        //== Wrap the table
        table.parentElement.insertBefore(tableContent, table)
        tableContent.appendChild(tableScroll)
        tableScroll.appendChild(table)
      }
    })
  }

  //== Simple debounce helper
  //== Wait until the user stops resizing for 150ms, then run once
  const debounce = (fn, delay) => {
    let timeout
    return () => {
      clearTimeout(timeout)
      timeout = setTimeout(fn, delay)
    }
  }

  //== Run on load
  wrapTables()

  //== Run on resize (debounced)
  window.addEventListener('resize', debounce(wrapTables, 150))
})
